module.exports = __webpack_public_path__ + "static/media/icon-qr.cd2b82d7.svg";